// extracted by mini-css-extract-plugin
export default {"inputCheck":"InputCheck_inputCheck__1gIO+"};